/**
 * User Repository Interface
 * Defines the contract for user data access
 */

export class IUserRepository {
  /**
   * Get all users
   * @returns {Promise<User[]>}
   */
  async getAllUsers() {
    throw new Error('getAllUsers must be implemented');
  }

  /**
   * Get user by ID
   * @param {string} userId - User ID
   * @returns {Promise<User|null>}
   */
  async getUserById(userId) {
    throw new Error('getUserById must be implemented');
  }

  /**
   * Get user by email
   * @param {string} email - User email
   * @returns {Promise<User|null>}
   */
  async getUserByEmail(email) {
    throw new Error('getUserByEmail must be implemented');
  }

  /**
   * Create user
   * @param {Object} userData - User data
   * @returns {Promise<User>}
   */
  async createUser(userData) {
    throw new Error('createUser must be implemented');
  }

  /**
   * Update user
   * @param {string} userId - User ID
   * @param {Object} updates - User updates
   * @returns {Promise<User>}
   */
  async updateUser(userId, updates) {
    throw new Error('updateUser must be implemented');
  }

  /**
   * Delete user
   * @param {string} userId - User ID
   * @returns {Promise<boolean>}
   */
  async deleteUser(userId) {
    throw new Error('deleteUser must be implemented');
  }

  /**
   * Get users enrolled in a course
   * @param {string} courseId - Course ID
   * @returns {Promise<User[]>}
   */
  async getUsersByCourse(courseId) {
    throw new Error('getUsersByCourse must be implemented');
  }

  /**
   * Enroll user in course
   * @param {string} userId - User ID
   * @param {string} courseId - Course ID
   * @returns {Promise<User>}
   */
  async enrollUserInCourse(userId, courseId) {
    throw new Error('enrollUserInCourse must be implemented');
  }

  /**
   * Unenroll user from course
   * @param {string} userId - User ID
   * @param {string} courseId - Course ID
   * @returns {Promise<User>}
   */
  async unenrollUserFromCourse(userId, courseId) {
    throw new Error('unenrollUserFromCourse must be implemented');
  }

  /**
   * Create the first admin account (bootstrap)
   * Must only succeed when no users exist
   * @param {Object} adminData - Initial admin data
   * @returns {Promise<User>}
   */
  async createInitialAdmin(adminData) {
    throw new Error('createInitialAdmin must be implemented');
  }
}
